export const validatePhoneNumber = (phone: string): boolean => {
  const withoutCountryCode = /^\(?(\d{2,5})\)?[- ]?(\d{3,4})[- ]?(\d{4})$/;
  const withCountryCode =
    /^\(?(\+\d{2})\)?[- ]?(\d{1,5})[- ]?(\d{3,4})[- ]?(\d{3,4})$/;
  const result = withoutCountryCode.test(phone) || withCountryCode.test(phone);
  return result;
};
